import React, { useState, useEffect } from 'react';
import otpimage from '../assets/otp-image.png';
import { useSendOtpMutation, useVerifyOtpMutation, useRegisterOtpMutation, useResendotpMutation } from '../redux/Api/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LoginPage = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState(new Array(6).fill(''));
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState('');
  const [step, setStep] = useState('login');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [sendOtp, { isLoading: sendingOtp }] = useSendOtpMutation();
  const [verifyOtp, { isLoading: verifyingOtp }] = useVerifyOtpMutation();
  const [resendotp] = useResendotpMutation();
  const [registerUser] = useRegisterOtpMutation();
  const [username, setUsername] = useState('');
  
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const { displayName, username } = JSON.parse(storedUser);
      setUsername(displayName || username || '');
    } else {
      console.log('No username stored.');
    }
  }, []);
  
  const handleSendOtp = async () => {
    if (phoneNumber.length !== 10 || !/^[6-9]\d{9}$/.test(phoneNumber)) {
      setError('Please enter a valid 10-digit phone number starting with 6 or higher.');
      return;
    }
    setError('');
    try {
      await sendOtp({ phone: `+91${phoneNumber}` }).unwrap();
      localStorage.setItem('Username', username || "");
      setOtpSent(true);
      setStep('otp');
      toast.success('OTP sent successfully!');
    } catch (error) {
      console.error('Error sending OTP:', error);
      setError('Failed to send OTP. Please try again.');
      toast.error('Failed to send OTP. Please try again.');
    }
  };
  const handleOtpSubmit = async () => {
    const otpString = otp.join('');
    try {
      const response = await verifyOtp({ phone: `+91${phoneNumber}`, otp: otpString }).unwrap();
      console.log('Response from verifyOtp:', response);
      const { isRegistered, username, _id } = response;
      if (isRegistered) {
        if (username && _id) {
          localStorage.setItem('userId', _id);

          localStorage.setItem('user', JSON.stringify({ _id, username }));
          toast.success(`Welcome back, ${username}! Redirecting to home page...`);
          window.location.href = '/';
        } else {
          setError('Failed to retrieve user details. Please try again.');
        }
      } else {
        setStep('register');
        toast.success('OTP verified successfully! Please complete registration.');
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      const errorMessage = error?.data?.message || 'Failed to verify OTP. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };
  const handleResendOtp = async () => {
    try {
      await resendotp({ phone: `+91${phoneNumber}` }).unwrap();
      toast.success('OTP resend successfully!');
    } catch (error) {
      console.error('Error resending OTP:', error);
      toast.error('Failed to resend OTP. Please try again.');
    }
  };
  const handleKeyDown = (e, index) => {
    const { key } = e;
    if (key === 'Backspace') {
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);

      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };
  const handleRegisterSubmit = async () => {
    const payload = {
      name,
      email,
      phonenumber: `+91${phoneNumber}`,
    };
    try {     
      const response = await registerUser(payload).unwrap();
      const { isRegistered, username, _id } = response;

      console.log('Response from registerUser:', response);
  
      localStorage.setItem('userId', _id);

      localStorage.setItem('user', JSON.stringify({ _id, username }));
      toast.success(`Welcome back, ${username}! Redirecting to home page...`);
      window.location.href = '/';
    } catch (error) {
      console.error(' Error registering user:', error);
      const errorMessage = error?.data?.error || 'Failed to register user. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };
  
  
  const handleOtpChange = (element, index) => {
    const value = element.value;
    if (value.length === 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhoneNumber(value);
    }
  };
  return (
    <div className="flex justify-center items-center min-h-screen pt-10 md:pt-40 md:p-6 lg:mt-[27px] lg:mb-[27px]">
      <div className="flex flex-col md:flex-row w-full max-w-5xl md:min-h-[70vh] h-auto md:space-x-6 space-y-4 md:space-y-0 p-4 sm:p-6 bg-gradient-to-t from-blue-600 to-blue-800 rounded-lg shadow-md">
        <div className="w-full md:w-1/2 bg-white rounded-lg flex justify-center items-center sm:text-center p-4 sm:p-8">
          <img src={otpimage} alt="OTP Illustration" className="w-full h-auto max-w-xs sm:max-w-md lg:max-w-xl object-cover rounded-lg shadow-md" />
        </div>
        <div className="w-full md:w-1/2 bg-white rounded-lg shadow-lg p-4 sm:p-8 flex flex-col items-start justify-center">
          {step === 'login' && (
            <>
              <h2 className="text-xl sm:text-3xl font-semibold mb-10 md:ml-32">Login</h2>
              <h2 className="text-xl sm:text-2xl mb-2 text-left">Enter Mobile Number</h2>
              <div className="flex items-center mb-2 w-full">
                <span className="px-2 py-2 border border-r-0 border-gray-400 bg-gray-200 rounded-l-md">+91</span>
                <input
                  type="number"
                  value={phoneNumber}
                  onChange={handlePhoneNumberChange}
                  placeholder="Enter Your Mobile Number"
                  className="w-full p-2 border border-gray-400 bg-gray-200 rounded-r-md"
                />
              </div>
              <p className='text-sm'>By providing my phone number, i hereby agree and accept the <a href="#terms-and-service" className='text-blue-700'>Terms of Services</a> and <a href="" className='text-blue-700'>Privacy Policy </a> in use of the Website</p>
              {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
              <button onClick={handleSendOtp} className="px-6 py-2 mt-8 lg:ml-64 text-white bg-blue-600 rounded-lg shadow-md hover:bg-blue-500 text-lg">
                Request OTP
              </button>
            </>
          )}
          {step === 'otp' && (
            <>
              <h2 className="text-xl sm:text-3xl justify-center font-semibold mb-4 md:ml-40">OTP</h2>
              <p className='mb-5 text-xl md:ml-16'> Please enter Your Verified Otp</p>
              <div className="flex justify-center font-bold space-x-3 md:ml-12 mb-4">
                {otp.map((data, index) => (
                  <input
                    key={index}
                    type="text"
                    id={`otp-input-${index}`}
                    maxLength="2"
                    value={data}
                    onChange={(e) => handleOtpChange(e.target, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className="w-10 h-10 text-center border border-gray-300 rounded-md text-lg"
                  />
                ))}
              </div>
              <button onClick={handleOtpSubmit} className="px-8 py-2 md:ml-36 text-white bg-blue-600 rounded-lg shadow-md hover:bg-blue-500 text-lg">
                Verify
              </ button>
              <p className='md:ml-16'>Not Received Your Code? <button onClick={handleResendOtp} className="mt-4 text-blue-600">Resend OTP</button></p>
            </>
          )}
          {step === 'register' && (
            <>
              <h2 className="text-xl sm:text-3xl font-semibold mb-4">Register</h2>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="User Name"
                className="mb-4 w-full p-2 border border-gray-400 bg-gray-200 rounded-md"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-Mail ID"
                className="mb-4 w-full p-2 border border-gray-400 bg-gray-200 rounded-md"
              />
              <input type="number" value={phoneNumber} disabled className="mb-4 w-full p-2 border border-gray-400 bg-gray-200 rounded-md" />
              <button onClick={handleRegisterSubmit} className="px-6 py-2 mt-4 text-white bg-blue-600 rounded-lg shadow-md hover:bg-blue-500 text-lg">
                Save
              </button>
            </>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
export default LoginPage;
